/**
 * Wahler-Backend
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum RfdPlace {

    REMOTE = 'REMOTE',

    ON_SITE = 'ON_SITE'
}

